<template>
  <app-confirm-dialog
    v-model="dialog"
    @confirm="confirm"
    @cancel="cancel"
    confirmBtnText="延長輔導"
    cancelBtnText="拒絕"
    :loading="loading"
    :showConfirmBtn="showConfirmBtn"
    :showCancelBtn="showCancelBtn">
    <div class="subheading">{{dialogText}}</div>
    <v-progress-linear
      v-if="countdownProgress"
      v-model="countdownPercentage"
      color="secondary" />
  </app-confirm-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

const getDefaultData = () => {
  return {
    loading: false,
    dialog: false,
    dialogText: '',
    showConfirmBtn: true,
    showCancelBtn: true,
    waitingTime: 0,
    countdownProgress: true
  };
};

export default {
  data: getDefaultData,
  computed: {
    ...mapState('fudao', {
      fudaoDto: state => state.fudaoDto,
      responseTimeout: state => state.responseTimeout
    }),

    isSelfInvite() {
      return this.fudaoDto.teacher.Id === this.userid;
    },

    countdownPercentage() {
      return Math.round(this.waitingTime/(this.responseTimeout/1000) * 100);
    }
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.reset();
      }
    },

    waitingTime(value) {
      if (value < this.responseTimeout/1000) {
        return;
      }

      this.stopCountdownProgress();
      this.sentNoResponse();
    }
  },

  mounted() {
    this.$eventBus.$on(FudaoEvent.StudentExtendInvitationReceived, this.onStudentExtendInvitationReceived);
  },

  beforeDestroy() {
    this.$eventBus.$off(FudaoEvent.StudentExtendInvitationReceived, this.onStudentExtendInvitationReceived);
    this.reset();
  },

  methods: {
    ...mapActions('alert', {
      addAlert: 'add'
    }),

    isDifferentFudao(domainEvent) {
      return this.fudaoDto.id && this.fudaoDto.id !== domainEvent.body.id;
    },

    stopCountdownProgress() {
      clearInterval(this._countdownTimeInterval);
      this.countdownProgress = false;
    },

    open() {
      this.dialog = true;
    },

    reset() {
      this.$eventBus.$off(FudaoEvent.TeacherExtendInvitationCanceled, this.onTeacherExtendInvitationCanceled);
      this.$eventBus.$off(FudaoEvent.StudentExtendInvitationNoReponse, this.onStudentExtendInvitationNoReponse);
      this.$eventBus.$off(FudaoEvent.FudaoExtended, this.onFudaoExtended);
      this.$eventBus.$off(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      this.stopCountdownProgress();
      let data = getDefaultData();
      Object.keys(data).forEach(key => this[key] = data[key]);
    },

    async confirm() {
      if (!this.isStudent || this.fudaoDto.teacher.Id === this.userid) {
        this.addAlert({level: 'error', content: '無法延長輔導: 角色錯誤'});
        this.dialog = false;
        return;
      }

      this.stopCountdownProgress();
      this.loading = true;
      this.showCancelBtn = false;
      await fudaoAppService.acceptExtendFudaoInvition(this.fudaoDto.id);
    },

    async cancel() {
      this.stopCountdownProgress();
      await fudaoAppService.rejectExtendFudaoInvition(this.fudaoDto.id);
      this.dialog = false;
    },

    sentNoResponse() {
      fudaoAppService.noResponseExtendFuadoAsync(this.fudaoDto.id);
    },

    // events ---------------------------------------------------

    onTeacherExtendInvitationCanceled(domainEvent) {
      if (this.isSelfInvite || this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'info', content: '老師取消邀請延長輔導'});
      this.dialog = false;
    },

    onStudentExtendInvitationReceived(domainEvent) {
      if (this.isSelfInvite || this.isDifferentFudao(domainEvent)) {
        return;
      }

      this.$eventBus.$on(FudaoEvent.TeacherExtendInvitationCanceled, this.onTeacherExtendInvitationCanceled);
      this.$eventBus.$on(FudaoEvent.StudentExtendInvitationNoReponse, this.onStudentExtendInvitationNoReponse);
      this.$eventBus.$on(FudaoEvent.FudaoExtended, this.onFudaoExtended);
      this.$eventBus.$on(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      this.dialogText = '是否要延長輔導?';
      this.dialog = true;

      this._countdownTimeInterval = setInterval(() => {
        this.waitingTime++;
      }, 1000);
    },

    onStudentExtendInvitationNoReponse(domainEvent) {
      if (this.isSelfInvite || this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'warning', content: '回應逾時'});
      this.dialog = false;
    },

    onFudaoExtended(domainEvent) {
      this.addAlert({level: 'info', content: '輔導已延長'});
      this.dialog = false;
    },

    onFudaoStartFailed(errMsg) {
      this.addAlert({level: 'error', content: '邀請延長輔導發生錯誤: ' + errMsg});
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>
